<template>
  <div class="cashier-choose">
    <div class="top-bar">
      <span class="top-title">选择工作台</span>
      <div class="top-right">
        <span v-if="storeName" class="top-store">{{ storeName }}</span>
        <span class="top-user">{{ userName }}</span>
        <a-button size="small" @click="handleLogout">退出登录</a-button>
      </div>
    </div>
    <div class="choose-body">
      <div v-if="hasRetail" class="choose-card retail" @click="go('/cashier/retail')">
        <a-icon class="card-icon" type="shopping-cart" />
        <div class="card-name">零售收银</div>
        <div class="card-desc">商品零售 · 会员结算</div>
      </div>
      <div v-if="hasDining" class="choose-card dining" @click="go('/cashier/dining')">
        <a-icon class="card-icon" type="coffee" />
        <div class="card-name">餐饮收银</div>
        <div class="card-desc">桌台开台 · 点餐结算</div>
      </div>
      <div v-if="!hasRetail && !hasDining" class="choose-empty">
        当前账号无可用收银工作台，请联系管理员分配权限
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { queryPermissionsByUser } from '@/api/api'
import { USER_ID, USER_INFO, ACCESS_TOKEN } from '@/store/mutation-types'
import { storeMy } from '@/api/plugin/dining'

const RETAIL_MENU_URL = '/plugin/member/cashier'
const DINING_MENU_URL = '/plugin/dining/cashier-entry'

/**
 * 独立收银端工作台选择页：按菜单权限展示零售/餐饮两大入口卡片，
 * 顶部显示当前用户与所属门店（sessionStorage 'diningStore'，缺失时回源 storeMy）
 */
export default {
  name: 'DiningCashierChoose',
  data() {
    return {
      userName: '',
      storeName: '',
      hasRetail: false,
      hasDining: false
    }
  },
  created() {
    this.initUserInfo()
    this.loadStoreInfo()
    this.scanPermission()
  },
  methods: {
    initUserInfo() {
      const info = Vue.ls.get(USER_INFO)
      this.userName = (info && (info.username || info.loginName)) || ''
    },
    loadStoreInfo() {
      let store = null
      try {
        store = JSON.parse(sessionStorage.getItem('diningStore') || 'null')
      } catch (e) {
        store = null
      }
      if (store && store.name) {
        this.storeName = store.name
        return
      }
      storeMy().then(res => {
        if (res.code === 200 && res.data && res.data.name) {
          this.storeName = res.data.name
          sessionStorage.setItem('diningStore', JSON.stringify(res.data))
        }
      }).catch(() => {})
    },
    // 权限扫描：优先读 store.permissionList（permission.js 登录跳转前已填充），为空再直调菜单接口
    scanPermission() {
      const menuData = this.$store.getters.permissionList
      if (menuData && menuData.length) {
        this.applyMenu(menuData)
        return
      }
      queryPermissionsByUser({ pNumber: 0, userId: Vue.ls.get(USER_ID) }).then(res => {
        this.applyMenu(res)
      }).catch(() => {})
    },
    applyMenu(menuData) {
      const urls = []
      const walk = list => {
        ;(list || []).forEach(m => {
          if (m.children && m.children.length > 0) {
            walk(m.children)
          } else if (m.url) {
            urls.push(m.url)
          }
        })
      }
      walk(menuData)
      this.hasRetail = urls.some(u => u.indexOf(RETAIL_MENU_URL) > -1)
      this.hasDining = urls.some(u => u.indexOf(DINING_MENU_URL) > -1)
    },
    go(path) {
      this.$router.push(path)
    },
    handleLogout() {
      // 清 USER_ID/token 相关缓存（照 user.js Logout 的 key 列表，另补 ACCESS_TOKEN 与本端门店缓存）后回登录页
      this.$store.dispatch('Logout').then(() => {
        Vue.ls.remove(ACCESS_TOKEN)
        sessionStorage.removeItem('diningStore')
        this.$router.push('/cashier/login')
      })
    }
  }
}
</script>

<style scoped>
.cashier-choose {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
}
.top-bar {
  height: 56px;
  flex-shrink: 0;
  background: #001529;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.top-title {
  font-size: 17px;
  font-weight: 600;
}
.top-right {
  display: flex;
  align-items: center;
}
.top-store {
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  margin-right: 14px;
}
.top-user {
  font-size: 13px;
  margin-right: 14px;
}
.choose-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.choose-card {
  width: 280px;
  height: 320px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s;
}
.choose-card + .choose-card {
  margin-left: 48px;
}
.choose-card:hover {
  transform: translateY(-6px);
}
.card-icon {
  font-size: 56px;
}
.choose-card.retail .card-icon {
  color: #2f54eb;
}
.choose-card.dining .card-icon {
  color: #fa8c16;
}
.card-name {
  font-size: 22px;
  font-weight: 600;
  margin-top: 22px;
  color: #222;
}
.card-desc {
  font-size: 13px;
  color: #999;
  margin-top: 10px;
}
.choose-empty {
  color: #999;
  font-size: 14px;
}
</style>
